import React from 'react'
import cx from 'classnames'
import Styles from './VisualSwitch.module.scss'

export type VisualSwitchProps = {
  active: boolean
  variant?: 'sm' | 'md' | 'lg'
  name?: string
}

export const VisualSwitch: React.FC<React.PropsWithChildren<VisualSwitchProps>> = ({
  active,
  variant = 'sm',
  name,
}) => {
  return (
    <div className={cx(Styles.switch, Styles[variant])}>
      <input type="checkbox" checked={active} readOnly name={name} aria-label={name} />
      <label className={Styles[variant]}></label>
    </div>
  )
}
